import React from 'react'
import { NavLink } from 'react-router-dom'

function CardVivier({vivier}) {

  // const secteur = (sectVivier)=>{
  //   switch (sectVivier) {
  //     case "Martinique":
  //        return "MQ"
  //     case "Guadeloupe":
  //       return "GP"
  //     default:
  //       break;
  //   }
  // }

  return (
    <NavLink to={`../ficheVivier/${vivier._id}`}>
      <div className='flex items-center p-3 border border-gray-100 rounded h-14 w-56'>
          <div className="w-full flex items-center gap-2">
            <div className="truncate text-lg text-gray-900 flex-1">
              {vivier.name}
            </div>
            <div className="text-sm text-gray-700 flex-shrink-0">
              {vivier.user_preferences?.length ?? 0}
            </div>
          </div>
      </div>
    </NavLink>
  )
}

export default CardVivier